import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import dayjs from 'dayjs'

import S3FileUpload from 'react-s3/lib/ReactS3'

import {
    Avatar,
    Button,
    Card,
    Drawer,
    Flex,
    Input,
    List,
    message,
    Spin,
    Typography,
    Upload,
} from 'antd'
import { PlusOutlined } from '@ant-design/icons'

import JobApplicantInfoCard from './JobApplicantInfoCard'
import PDFImg from '../../../assets/images/pdf.png'
import { loginState } from '../../login/login.slice'
import { apiAddJobApplicationNote } from '../store/jobApplicant.service'
import {
    getJobApplicationNotes,
    jobApplicantState,
} from '../store/jobApplicant.slice'

const initialNoteState = {
    submitDescription: null,
    attachment: null,
    isSubmit: false,
    fileList: [],
}

const JobApplicantNotes = ({
    state,
    setState,
    JobApplicationState,
    handleUpdateJobApplicationStatus,
}) => {
    const params = useParams()
    const dispatch = useDispatch()

    const { Text, Paragraph } = Typography

    const { userProfile } = useSelector(loginState)
    const jobApplicantData = useSelector(jobApplicantState)

    const [noteState, setNoteState] = useState(initialNoteState)

    const handleDownloadResume = async (data) => {
        const resume = data?.attachments

        if (resume?.url && resume?.name) {
            try {
                const response = await fetch(resume.url)
                if (!response.ok) {
                    throw new Error('Network response was not ok')
                }
                const blob = await response.blob()
                const url = window.URL.createObjectURL(blob)
                const a = document.createElement('a')
                a.href = url
                a.download = resume.name
                document.body.appendChild(a)
                a.click()
                document.body.removeChild(a)
                window.URL.revokeObjectURL(url)
            } catch (error) {
                console.error('Failed to download resume:', error)
            }
        } else {
            console.error('Resume URL or name is missing')
        }
    }

    const uploadS3File = (file, fileList) => {
        const nameChange = file?.name
            .split('.')[0]
            .replace(/\s+/g, '_')
            .concat(`_${dayjs(new Date()).unix()}`)
            .concat(`.${file?.name.split('.')[1]}`)

        const newFileData = new File([file?.originFileObj], nameChange, {
            type: file?.type,
        })

        window.Buffer = window.Buffer || require('buffer').Buffer

        setNoteState((prevState) => ({
            ...prevState,
            isSubmit: true,
        }))

        S3FileUpload.uploadFile(newFileData, userProfile?.s3Config)
            .then(async (data) => {
                setNoteState((prevState) => ({
                    ...prevState,
                    attachment: {
                        name: file?.name,
                        url: data?.location,
                        fileType: file?.type,
                    },
                    isSubmit: false,
                    fileList: fileList,
                }))
            })
            .catch(() => {
                setNoteState((prevState) => ({
                    ...prevState,
                    attachment: null,
                    isSubmit: false,
                }))
                message.error('Upload Failed!. Please Upload again')
            })
    }

    const props = {
        name: 'file',
        accept: '.pdf',
        beforeUpload: (file, fileList) => {
            uploadS3File(file, fileList)
            return false
        },
        maxCount: 1,
        onChange(info) {
            if (info.file.status !== 'uploading') {
                console.log('---uploaded')
            }
        },
        onRemove(file, fileList) {
            setNoteState((prevState) => ({
                ...prevState,
                attachment: null,
                fileList: [],
            }))
        },
    }

    const handleSubmitNotes = async () => {
        try {
            const data = {
                description: noteState?.submitDescription,
                attachments: noteState?.attachment,
                userId: state?.selectedApplicantData?.candidateId,
                jobId: params?.id,
                createBy: userProfile?._id,
            }

            setNoteState((prevState) => ({
                ...prevState,
                isSubmit: true,
            }))

            const res = await apiAddJobApplicationNote(data)

            if (res?.data?.success) {
                message.success('Note submitted successfully')
                setNoteState(initialNoteState)
                dispatch(
                    getJobApplicationNotes({
                        userId: state?.selectedApplicantData?.candidateId,
                    })
                )
            } else {
                message.error('Failed to submit note')
                setNoteState(initialNoteState)
            }
        } catch (error) {
            message.error('Failed to submit note')
            setNoteState(initialNoteState)
        }
    }

    useEffect(() => {
        if (state?.selectedApplicantData?.candidateId) {
            dispatch(
                getJobApplicationNotes({
                    userId: state?.selectedApplicantData?.candidateId,
                })
            )
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state?.selectedApplicantData?._id])

    return (
        <>
            <Drawer
                placement="right"
                closable={false}
                open={state?.jobApplicantNotesDrawer}
                onClose={() => {
                    setState((prevState) => ({
                        ...prevState,
                        jobApplicantNotesDrawer: false,
                    }))
                }}
                footer={null}
                title={null}
                style={{
                    height: '100vh',
                    minWidth: '1000px',
                    width: '1000px',
                }}
                styles={{
                    body: {
                        display: 'flex',
                        flexDirection: 'column',
                        height: '100%',
                        padding: 0,
                    },
                    wrapper: {
                        width: 'auto !important',
                    },
                }}
                rootClassName="talentViewDrawer"
            >
                <div
                    style={{
                        padding: '20px 30px',
                        borderBottom: '1px solid #f0f0f0',
                    }}
                >
                    <JobApplicantInfoCard
                        state={state}
                        setState={setState}
                        handleUpdateJobApplicationStatus={
                            handleUpdateJobApplicationStatus
                        }
                        JobApplicationState={JobApplicationState}
                    />
                </div>

                <div
                    style={{
                        flex: 1,
                        overflowY: 'auto',
                        padding: '20px 30px',
                        background: '#fafafa',
                    }}
                >
                    {jobApplicantData?.notesLoading ? (
                        <Flex
                            align="center"
                            justify="center"
                            style={{ height: '100%' }}
                        >
                            <Spin />
                        </Flex>
                    ) : jobApplicantData?.notesList?.length > 0 ? (
                        <List
                            itemLayout="vertical"
                            dataSource={jobApplicantData?.notesList}
                            renderItem={(data) => (
                                <List.Item
                                    style={{
                                        background: '#fff',
                                        borderRadius: '12px',
                                        padding: '16px',
                                        marginBottom: '16px',
                                        boxShadow: '0 2px 6px rgba(0,0,0,0.05)',
                                    }}
                                >
                                    <List.Item.Meta
                                        avatar={
                                            data?.createBy?.profilePicture ? (
                                                <Avatar
                                                    src={
                                                        data?.createBy
                                                            ?.profilePicture
                                                    }
                                                />
                                            ) : (
                                                <Avatar>
                                                    {data?.createBy
                                                        ?.name?.[0] || ''}
                                                </Avatar>
                                            )
                                        }
                                        title={
                                            <Flex
                                                justify="space-between"
                                                align="center"
                                            >
                                                <Text strong>
                                                    {data?.createBy?.name}
                                                </Text>
                                                <Text
                                                    type="secondary"
                                                    style={{ fontSize: 12 }}
                                                >
                                                    {data?.createdAt
                                                        ? dayjs(
                                                              data?.createdAt
                                                          ).format(
                                                              'DD-MM-YYYY hh:mm A'
                                                          )
                                                        : '-'}
                                                </Text>
                                            </Flex>
                                        }
                                        description={
                                            <Paragraph>
                                                {data?.description}
                                            </Paragraph>
                                        }
                                    />

                                    {data?.attachments && (
                                        <Card
                                            hoverable
                                            size="small"
                                            onClick={() =>
                                                handleDownloadResume(data)
                                            }
                                            style={{
                                                maxWidth: 300,
                                                marginTop: 12,
                                                borderRadius: 8,
                                                background: '#f4f6f8',
                                            }}
                                        >
                                            <Flex align="center" gap={8}>
                                                {data?.attachments?.fileType
                                                    ?.toLowerCase()
                                                    .includes('pdf') && (
                                                    <img
                                                        src={PDFImg}
                                                        alt="pdf"
                                                        width={24}
                                                    />
                                                )}
                                                <Text ellipsis>
                                                    {data?.attachments?.name}
                                                </Text>
                                            </Flex>
                                        </Card>
                                    )}
                                </List.Item>
                            )}
                        />
                    ) : (
                        <Flex
                            align="center"
                            justify="center"
                            style={{ height: '100%' }}
                        >
                            <Text type="secondary">No notes found</Text>
                        </Flex>
                    )}
                </div>

                {/* Add Note Section */}
                <div
                    style={{
                        padding: '16px 30px',
                        borderTop: '1px solid #f0f0f0',
                        background: '#fff',
                    }}
                >
                    <Flex vertical gap={12}>
                        <Upload fileList={noteState.fileList} {...props}>
                            <Button type="link" icon={<PlusOutlined />}>
                                Attachment
                            </Button>
                        </Upload>

                        <Input.TextArea
                            rows={3}
                            value={noteState?.submitDescription}
                            onChange={(event) =>
                                setNoteState((prevState) => ({
                                    ...prevState,
                                    submitDescription: event.target.value,
                                }))
                            }
                            placeholder="Write a note..."
                            style={{ borderRadius: 8 }}
                        />

                        <Flex justify="flex-end">
                            <Button
                                type="primary"
                                onClick={handleSubmitNotes}
                                disabled={noteState?.isSubmit}
                                loading={noteState?.isSubmit}
                            >
                                Add Note
                            </Button>
                        </Flex>
                    </Flex>
                </div>
            </Drawer>
        </>
    )
}

export default JobApplicantNotes
